import React from 'react';

// The original Zoea drawing animation (a9b348f, AnimatedZoeaMark): same geometry, classes and timings.
// The keyframes and .zoea-mark-* classes live in src/index.css; landing.css only adds the one-time intro placement
// and the reduced-motion end state.
const HeroIntroMark = () => (
  <svg className="zl-intro-mark zoea-animated-mark" data-testid="hero-intro-mark" viewBox="0 0 200 200" fill="none" aria-hidden="true">
    <path
      className="zoea-mark-circle"
      d="M 108.4 32.7 A 70 70 0 1 1 91.6 32.7"
      stroke="#0E1015"
      strokeWidth="4.4"
      strokeLinecap="round"
      pathLength="1"
    />
    <path className="zoea-mark-stem" d="M 100 30 L 100 12" stroke="#0E1015" strokeWidth="4.4" strokeLinecap="round" pathLength="1" />
    <circle className="zoea-mark-dot" cx="100" cy="8" r="6" fill="#D4A574" />
  </svg>
);

export default HeroIntroMark;
